import PropTypes from 'prop-types';
import React from 'react';
import styles from './AvailabilityChecker.scss';
import { CardDescriptionList as DescriptionList } from '../../Elements';
import moment from 'moment-timezone';
import { withRouter } from 'found';
import LocationUtils from '../../../lib/utils/location';
import DateUtils from '../../../lib/utils/date';

const AgendaViewComponent = class AgendaView extends React.Component {
  static propTypes = {
    eventsOnDay: PropTypes.array.isRequired,
    selectedDay: PropTypes.object.isRequired,
    close: PropTypes.func,
    router: PropTypes.object.isRequired,
    closeAvailabilityChecker: PropTypes.func,
    timeZone: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.openEvent = this.openEvent.bind(this);
  }

  openEvent(event) {
    /* eslint-disable no-underscore-dangle */
    this.props.router.push(`/events/${event.event.id}`);
    if (this.props.close && this.props.closeAvailabilityChecker) {
      this.props.close();
      this.props.closeAvailabilityChecker();
    }
  }

  render() {
    const timeZone = this.props.timeZone || moment.tz.guess();
    const getVenueTitle = eventSegment =>
      (eventSegment.node.location || '') +
      (eventSegment.node.room ? ` (${eventSegment.node.room})` : '');
    const getDateFormat = eventSegment =>
      (eventSegment.node.all_day ? 'L' : 'L [at] LT');
    const getVenueText = eventSegment =>
      <div>
        {getVenueTitle(eventSegment)}
        {eventSegment.node.line1 && <br />}
        {eventSegment.node.line1}
        {(eventSegment.node.city ||
          eventSegment.node.province ||
          eventSegment.node.postal_code) &&
          <br />}
        {LocationUtils.getLocalityString({
          city: eventSegment.node.city,
          province: eventSegment.node.province,
          postal_code: eventSegment.node.postal_code
        })}
      </div>;

    const events = this.props.eventsOnDay.map((eventOnDay, eventIndex) => {
      const event = eventOnDay.node;
      return (
        <div key={eventIndex} style={{ textAlign: 'left', margin: '2em 0' }}>
          <h4
            onClick={this.openEvent.bind(null, event)}
            className={styles.eventName}
            style={{ cursor: 'pointer' }}
          >
            {event.event.title}
          </h4>

          {event.user_event_segments.edges.map((eventSegment, segmentIndex) =>
            <div key={segmentIndex} className={styles.cardSection}>
              <h5>
                {eventSegment.node.title}
              </h5>
              {moment(eventSegment.node.start_at).isValid() &&
                moment(eventSegment.node.end_at).isValid &&
                <div>
                  <DescriptionList
                    label='Starts'
                    value={DateUtils.isoStringToMoment(
                      eventSegment.node.start_at,
                      eventSegment.node.all_day,
                      timeZone
                    ).format(getDateFormat(eventSegment))}
                  />
                  <br />
                  <DescriptionList
                    label='Ends'
                    value={DateUtils.isoStringToMoment(
                      eventSegment.node.end_at,
                      eventSegment.node.all_day,
                      timeZone
                    ).format(getDateFormat(eventSegment))}
                  />
                </div>}
              {eventSegment.node.location &&
                <div>
                  <br />
                  <DescriptionList
                    label='Venue'
                    value={getVenueText(eventSegment)}
                  />
                </div>}
            </div>
          )}
        </div>
      );
    });
    return (
      <div>
        {events.length === 0 &&
          <h4 style={{ textAlign: 'center', marginTop: '2em' }}>
            No events on{' '}
            {moment(this.props.selectedDay).format('MMMM Do, YYYY')}
          </h4>}
        {events}
      </div>
    );
  }
};

export default withRouter(AgendaViewComponent);



// WEBPACK FOOTER //
// ./webpack/components/Modules/AvailabilityChecker/AgendaView.js